<template>
    <div id="task">
        <template v-if="cantAccessPagelien === true">
            <div class="container-fluid xyz">
                <div :class="'page-header-top-container'+titleMargin">
                    <div class="page-name color-71aa3f">{{LienPageData.pageTitle}}</div>
                    <template v-for="(permission, index) in permissionslien">
                        <button title="Add" v-if="permission.name == 'can_add_new_lien'"  type="button" class="btn general-button btn-primary icon-btn" id="submit" name="submit"
                                v-on:click.prevent="editlien">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>

                        <!--button title="Import" v-if="permission.name == 'can_import_tasks_data' && LienPageData.cus_id == 0" type="button" class="btn general-button btn-primary icon-btn" data-toggle="modal" data-target="#TaskdefaultModal">
                            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                        </button>
                        <button title="Export" v-if="permission.name == 'can_export_tasks_data'" type="button" id='exportTask' class="btn general-button btn-primary icon-btn"
                                v-on:click="exportTask($event)">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                        </button-->
                    </template>
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_all_task btn general-button btn-primary" v-on:click="allClick()">All</button>
                        <button type="button" class="btn_my_task btn general-button btn-secondary" v-on:click="myClick('my')">My Self</button>
                        <button type="button" class="btn_deleted_task btn general-button btn-secondary" v-on:click="myClick('deleted')">Archived</button>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <label>Expiry Date</label>
                        <date-picker
                            v-model="dateRange"
                            range
                            type="date"
                            placeholder="Select date range"
                            :format="datePickerFormat"
                            @change="handleDateRangeChange()"
                            />
                        <vue-good-table class="lienTable"
                                        ref="listlienTable"
                                        mode="remote"
                                        title="lien"
                                        @on-page-change="onPageChangeLien"
                                        @on-selected-rows-change="selectionChangedlien"
                                        @on-column-filter="onColumnFilterlien"
                                        @on-per-page-change="onPerPageChangeLien"
                                        @on-sort-change="onSortChangeLien"
                                        :totalRows="totalRecordsLien"
                                        :columns="columnsLien"
                                        :rows="rowsLien"
                                        :pagination-options="{
                                            enabled: true,
                                            mode: 'pages',
                                            pageLabel: 'Page',
                                            position: 'bottom',
                                            perPage: serverParamslien.perPage,
                                            setCurrentPage: serverParamslien.setCurrentPage,
                                            perPageDropdown: serverParamslien.perPageDropdown,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                            enabled: false,
                                        }"
                                        :row-style-class="rowStyleClassFn"
                                        >
                            <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm" v-if="totalRecordsLien > 0">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParamslien.perPage"
                                                      @change="changedValuelien"
                                                      @input="changedValuelienCustomPerPagelien()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="serverParamslien.perPageDropdown"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayrowsLien}} of {{totalRecordsLien}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParamslien.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClicklien(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParamslien.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClicklien(Number(serverParamslien.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberListlien() < displayPagelien">
                                                    <template v-for="(n, index) in pageNumberListlien()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamslien.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClicklien(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParamslien.page) <= pageComparelien">
                                                        <template v-for="(n, index) in displayPagelien">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamslien.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClicklien(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParamslien.page) >= (pageNumberListlien() - (pageComparelien-1))">
                                                        <template v-for="(n, index) in pageNumberListlien()">
                                                            <template v-if="n > (pageNumberListlien() - displayPagelien)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamslien.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClicklien(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberListlien()" v-if="(n >= (Number(serverParamslien.page) - (pageComparelien -1))) && (n <= (Number(serverParamslien.page) + (pageComparelien -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamslien.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClicklien(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParamslien.page) == pageNumberListlien()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClicklien(Number(serverParamslien.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParamslien.page) == pageNumberListlien()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListlien()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClicklien(pageNumberListlien())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListlien()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInlien" v-model="jumpToPagelien" type="text" class="form-control form-control-sm" name="jumpToPagelien" id="jumpToPagelien" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>


                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rowsLien">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <template v-if="permission.name == 'can_add_new_lien'" v-for="(permission, index) in permissionslien">
                                            <router-link title='Edit lien' class="btn edit-btn-vvg" v-bind:to="{name: 'EditLien',params:{id:props.row.id,from:LienPageData.cus_id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                                        </template>
                                    </div>
                                    <div v-if="props.column.field == 'status'">
                                        <span v-if="props.row.status == 'Beyleft'">Bailiff</span>
                                        <span v-else-if="props.row.status == 'Beyleaves'">Bailee’s</span>
                                        <span v-else-if="props.row.status == 'Paid'">Paid/Discharged</span>
                                        <span v-else> {{props.formattedRow[props.column.field]}}</span>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <template  v-for="(permission, index) in permissionslien">
                                <div slot="selected-row-actions">
                                    <button title='Delete lien' v-if="permission.name == 'can_add_new_lien' && messageTask != 'deleted'" id="deleteTaskBtn" v-on:click.prevent="onDeleteClick" class="btn general-button btn-success">Archive</button>
                                </div>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access lien.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import SessioMixin from '../../mixins/sessionmixin';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import EventBus from '../event-bus';
    import {addTask} from '../../config';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    export default {
        name: "taskcomponent",
        mixins: [SessioMixin],
        props: {
            LienPageData: '',
        },
        components: {
            DatePicker,
        },
        data: () => ({
                titleMargin: '',
                displayPagelien: 7,
                pageComparelien: 0,
                paginationDisplayrowsLien: '',
                jumpToPagelien: 0,

                loginIDTask: 0,
                permissionslien: [],
                cantAccessPagelien: true,
                messageTask: 'all',
                // filteredFlag: false,
                exportFilteredFlagTask: false,
                filesTask: [],
                isLoggedInTask: false,
                firstLoadTask: 0,
                isHideColumns: false,
                columnsLien: [
                    {
                        label: 'CusId',
                        field: 'customer_id',
                        filterable: true,
                        sortable: false,
                        hidden: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customer_first_name',
                        filterable: true,
                        sortable: false,
                        hidden: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Lien#',
                        field: 'lien_number',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Lien#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Serial#',
                        field: 'serial_number',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Serial#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'RO#',
                        field: 'ro_number',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "RO#", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },

                    {
                        label: 'Lien Amount',
                        field: 'lien_amount',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Lien Amount", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Issue Date',
                        field: 'issue_date',
                        filterable: true,
                        sortable: false,
                        // dateInputFormat: 'DD/MM/YYYY HH:mm:ss',
                        dateOutputFormat: 'DD/MM/YYYY',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Issue Date", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Expiry Date',
                        field: 'expiry_date',
                        filterable: false,
                        sortable: false,
                        // dateInputFormat: 'DD/MM/YYYY HH:mm:ss',
                        dateOutputFormat: 'DD/MM/YYYY',
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Expiry Date", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Status", // placeholder for filter input
                            filterDropdownItems: [
                                {
                                    'text':'Active','value':'active'
                                },
                                {
                                    'text':'Bailiff','value':'beyleft'
                                },
                                {
                                    'text':'Bailee’s','value':'beyleaves'
                                },
                                {
                                    'text':'Paid/Discharged','value':'paid'
                                }
                            ],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created By',
                        field: 'created_first_name',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created At',
                        field: 'created_at',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
                        sortable: false,
                        // dateOutputFormat: 'MM/DD/YYYY',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '106px',
                    },
                ],
                rowsLien: [],
                dateRange: [],
                totalRecordsLien: 0,
                serverParamslien: {
                    columnFilters: {},
                    sort: {
                        field: 'created_at',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    perPageDropdown: [],
                },
                datePickerFormat: (process.env.VUE_APP_DATE_FORMAT != undefined) ? process.env.VUE_APP_DATE_FORMAT : 'MM-DD-YYYY'
            }),
            computed: {
                filteredRows() {
                if (!this.dateRange.length) {
                    return this.rows;
                }

                const [startDate, endDate] = this.dateRange.map(date => new Date(date));
                return this.rows.filter(row => {
                    const rowDate = new Date(row.expiry_date);
                    return rowDate >= startDate && rowDate <= endDate;
                });
                }
            },
        beforeMount: function () {
            var self = this;
            // self.isHideColumns = self.LienPageData.is_cust_detail;

            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                self.isLoggedInTask = true;
                self.getpermissionslien();

            }
        },
        mounted: function () {

            var app = this;
            app.isHideColumns = app.LienPageData.is_cust_detail;
            app.loadFilters('menulien', app.columnsLien, app.serverParamslien, "lienTable");
            var initial = process.env.ROOT_API;
            var initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Tasks.xlsx');
            app.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginIDTask = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            this.jumpToPagelien = this.serverParamslien.page;
            this.pageComparelien = Math.ceil(this.displayPagelien / 2);
            $("#jumpToPagelien").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPagelien(app.jumpToPagelien)
                }
            });
            if (app.LienPageData.is_part == 1) {
                app.titleMargin = " pt-0";
            }
            this.serverParamslien.perPage = this.LienPageData.perPage;
            for (var i = this.LienPageData.perPage; i < 100; ) {
                this.serverParamslien.perPageDropdown.push(i);
                if (this.LienPageData.perPage < 5) {
                    i = i * 5;
                } else {
                    i = i * 2;
                }
            }
            this.serverParamslien.perPageDropdown.push(100);
            this.serverParamslien.perPageDropdown.push(200);
            this.serverParamslien.perPageDropdown.push(500);
            
            this.loadLienComponent();
            
        },
        methods: {
            rowStyleClassFn: function(row) {
                if(row.is_about_expire == 'yes') {
                    return 'bgChange';
                }
            },
            dateFilter(value, row) {
                if (!this.dateRange.length) {
                    return true;
                }

                const [startDate, endDate] = this.dateRange.map(date => new Date(date));
                const rowDate = new Date(row.expiry_date);
                return rowDate >= startDate && rowDate <= endDate;
            },
            handleDateRangeChange(evt){

                if (!this.dateRange || this.dateRange[0] == null){
                    this.serverParamslien.columnFilters.expiry_date = '';
                }else{
                    this.serverParamslien.columnFilters.expiry_date = this.dateRange;
                }
                this.loadLienComponent();
            },
            jumpToPageInlien: function (e) {
                let self = this;
                self.jumpToInputPagelien(self.jumpToPagelien);
            },
            changedValuelien: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPagelien: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListlien()) {
                    pageNumber = self.pageNumberListlien();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPagelien).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClicklien(pageNumber);
            },
            onPerticularPageClicklien: function (pageNumber) {
                var self = this;
                self.serverParamslien.page = pageNumber;
                self.jumpToPagelien = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoadTask != 1 && self.jumpToPagelien != 1) {
                  self.loadLienComponent();

                } else if(self.firstLoadTask == 1 && self.jumpToPagelien >=1) {
                    self.loadLienComponent();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberListlien: function () {
                var self = this;
                var totalRecord = self.totalRecordsLien;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParamslien.perPage;
                    count++;
                }
                return count;
            },
            changedValuelienCustomPerPagelien: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoadTask != 1) {
                self.jumpToInputPagelien(self.serverParamslien.page);
                self.loadLienComponent();
                }
                /* Single Backend Call on page load end */
            },
            /* Custome pagination Methods End */
            getpermissionslien: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagTask = false;
                        if (data.status == 'success') {
                            self.cantAccessPagelien = false;
                            self.permissionslien = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissionslien.length > 0) {
                                for (var i = 0; i < self.permissionslien.length; i++) {
                                    if (self.permissionslien[i].name == 'can_see_lien_list') {
                                        self.cantAccessPagelien = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPagelien = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            
            updateParamslien(newProps) {
                this.serverParamslien = Object.assign({}, this.serverParamslien, newProps);
            },
            onPageChangeLien(params) {
                this.updateParamslien({page: params.currentPage});
                this.loadLienComponent();
            },
            onPerPageChangeLien(params) {
                this.updateParamslien({perPage: params.currentPerPage});
                this.totalRecordsLien = this.totalRecordsLien;
                this.loadLienComponent();
            },

            onColumnFilterlien(params) {
                this.updateParamslien(params);
                {
                    field: ('lien_number');
                    field: ('ro_number');
                    field: ('status');
                    field:('issue_date');
                    field:('serial_number');
                    field:('cusid');
                    field:('customer_first_name');
                    field:('expiry_date');
                }
                ;
                this.serverParamslien.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamslien));
                var filters = filtersPr.columnFilters;

                if (this.firstLoadTask == 1 || filters.lien_number || filters.issue_date || filters.status || filters.expiry_date
                        || filters.ro_number || filters.serial_number || filters.lien_amount || filters.customer_id || filters.customer_first_name || filters.first_name || filters.action) {
                    this.filteredFlag = true;
                    console.log("onColumnFilterlien");
                    this.loadLienComponent();
                }

            },
            selectionChangedlien() {

                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            editlien() {

                var self = this;
                if(self.LienPageData.cus_id > 0) {
                  self.$router.push("/lien/create/" + self.LienPageData.cus_id);
                } else {
                  self.$router.push("/lien/create/"+ self.LienPageData.cus_id);
                }
                
            },
            onSortChangeLien(params) {
                this.updateParamslien({
                    sort: {
                        type: params.sortType,
                        field: this.columnsLien[params.columnIndex].field,
                    },
                });
                console.log("onSortChangeLien");
                this.loadLienComponent();
            },
            handleFilesUpload: function () {
                /*
                 Get the uploaded filesTask from the input.
                 */
                var self = this;
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesTask.files;
                //console.log(uploadedFiles);
                /*
                 Assign the uploaded file to the filesTask array
                 */
                /*this.filesTask.pop();*/
                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesTask = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
            hideModel() {
                $('#TaskdefaultModal').modal('hide');
                return false;
            },
            allClick: function () {
                var self = this;
                self.messageTask = 'all';
                console.log("allClick");
                self.loadLienComponent();
            },
            myClick: function (flag) {
                var self = this;
                self.messageTask = flag;
                self.serverParamslien.page = 1;
                self.jumpToPagelien = 1;
                console.log("myClick");
                self.loadLienComponent();
            },
            loadLienComponent: function () {
                var self = this;
                self.serverParamslien.setCurrentPage = self.serverParamslien.page;
                if (self.messageTask == 'my') {
                    $(".btn_all_task").removeClass("btn-primary");
                    $(".btn_all_task").addClass("btn-secondary");
                    $(".btn_deleted_task").removeClass("btn-primary");
                    $(".btn_deleted_task").addClass("btn-secondary");

                    $(".btn_my_task").removeClass("btn-secondary");
                    $(".btn_my_task").addClass("btn-primary");
                }else if (self.messageTask == 'deleted'){

                    $(".btn_my_task").removeClass("btn-primary");
                    $(".btn_my_task").addClass("btn-secondary");
                    $(".btn_all_task").removeClass("btn-primary");
                    $(".btn_all_task").addClass("btn-secondary");

                    $(".btn_deleted_task").removeClass("btn-secondary");
                    $(".btn_deleted_task").addClass("btn-primary");
                } else {
                    $(".btn_my_task").removeClass("btn-primary");
                    $(".btn_my_task").addClass("btn-secondary");
                    $(".btn_deleted_task").removeClass("btn-primary");
                    $(".btn_deleted_task").addClass("btn-secondary");

                    $(".btn_all_task").removeClass("btn-secondary");
                    $(".btn_all_task").addClass("btn-primary");
                }
                if (!self.dateRange.length){
                    self.serverParamslien.columnFilters.expiry_date = '';
                }
                if (self.LienPageData.cus_id > 0) {
                    var fields = {
                        page: self.serverParamslien.page,
                        perPage: self.serverParamslien.perPage,
                        filters: self.serverParamslien.columnFilters,
                        messageData: self.messageTask,
                        sort: self.serverParamslien.sort,
                        exportFiltered: self.exportFilteredFlagTask,
                        custid: self.LienPageData.cus_id
                    };
                    self.storeFilters('menutaskscustomer', self.serverParamslien, false);
                } else {
                    var fields = {
                        page: self.serverParamslien.page,
                        perPage: self.serverParamslien.perPage,
                        filters: self.serverParamslien.columnFilters,
                        messageData: self.messageTask,
                        sort: self.serverParamslien.sort,
                        exportFiltered: self.exportFilteredFlagTask
                    };
                    self.storeFilters('menulien', self.serverParamslien, false);
                }
                self.firstLoadTask = 1;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/lien/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagTask = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsLien = data.content.row;
                            self.totalRecordsLien = data.content.totalRecords;
                            self.showHidePagination("lienTable", self.totalRecordsLien);
                            self.filteredFlag = false;
                            self.jumpToPagelien = self.serverParamslien.page;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportTask').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportTask').prop("disabled", false);
                            location.href = data.content.web;
                        }
                        self.paginationDisplayrowsLien = self.getRecords(self.serverParamslien.page, self.serverParamslien.perPage, self.totalRecordsLien);
                        self.hideLoader();
                        if (self.LienPageData.cus_id > 0){
                            self.checkLeanExpiry(self.LienPageData.cus_id);
                        }
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });

            },
            checkLeanExpiry(cusId){
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/check/lean-expiry/"+cusId,
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.$parent.lienMessage = data.content;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            onDeleteClick() {
                //console.log("selected rows", self.$refs['listTaskTable'].selectedRows)
                var self = this;
                var data = self.$refs['listlienTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(self.$refs['listlienTable'].selectedRows[i].id)
                }
                // console.log(use)
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Archive it!'
                }).then((result) => {
                    if (result.value) {
                        $("#deleteTaskBtn").val("Deleting ...");
                        $.ajax({
                            url: process.env.ROOT_API + "/lien/delete",
                            type: "POST",
                            data: 'ids=' + use,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                setTimeout(function () {
                                    $(".alert-success").removeClass("show");
                                    $(".alert-success").addClass("hide");
                                }, 5000);
                                setTimeout(function () {
                                    $("#deleteTaskBtn").val("Delete");
                                }, 10000);
                                self.rowsLien = data.content.row;
                                if (data.code == '200') {
                                    // alert("Hii");
                                    self.rowsLien = data.content.row;
                                    self.totalRecordsLien = data.content.totalRecords;
                                    console.log("onDeleteClick");
                                    self.loadLienComponent();
                                }
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }

                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                });
            },
        }
    }
</script>
<style>
.bgChange {
    color: rgb(223, 150, 150) !important;
    background: rgb(223, 172, 172) !important;
    border-bottom: 2px solid #f5f5f5 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/lien/ListLienComponent.vue